import { DataVehicles, NormalizedVoucher, VouchersCampaign } from '@esportal/portal-service';

export const noVehicleOrder2025 = (vehicles: DataVehicles | null): boolean => {
	if (!vehicles) {
		return false;
	}

	// Verificar si hay alguna fecha de 2025
	for (const order of vehicles.orders ?? []) {
		if (order.vgedCustomersOrderDate && new Date(order.vgedCustomersOrderDate).getFullYear() === 2025) {
			return false;
		}
	}

	for (const vehicle of vehicles.vehicles) {
		if (vehicle.vgedRegistrationDate && new Date(vehicle.vgedRegistrationDate).getFullYear() === 2025) {
			return false;
		}
	}

	return true;
};

export const voucherAlertExists = (campaign: VouchersCampaign, normalizedVouchers: NormalizedVoucher[]): boolean => {
	return normalizedVouchers.some((voucher) => voucher.campaign === campaign);
};
